// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OverflownTooltipText_overflown-text-container___hkL0{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", "",{"version":3,"sources":["webpack://./src/components/OverflownTooltipText/OverflownTooltipText.scss"],"names":[],"mappings":"AAAA,sDACE,eAAA,CACA,sBAAA,CACA,kBAAA","sourcesContent":[".overflown-text-container {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overflown-text-container": "OverflownTooltipText_overflown-text-container___hkL0"
};
export default ___CSS_LOADER_EXPORT___;
